export const UUID_REGEX_STRING =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
export const GLOBAL_UUID_REGEX = new RegExp(UUID_REGEX_STRING, 'g');

export const LOYALTY_PHYSICAL_CARD_NUMBER_LENGTH = 12;
